<app-common-modal-wrapper
  icon="ic-assign-to-existing-20"
  header="Assign to Existing"
  [isLoading]="isLoading()"
  [isDisabled]="selectedIndividualRecords.length == 0"
  (close)="close()"
  (submitModal)="submit()"
>
  @if (isLoading()) {
    <app-loader/>
  } @else {
    <app-list-grid-client-side
      rowSelection="single"
      [colDefs]="colDefs"
      [rowData]="individuals"
      [pagination]="false"
      (select)="onSelectIndividual($event)"
    />
  }
</app-common-modal-wrapper>
